<template>
    <b-card>
        <loader :loader="isLoading" v-if="isLoading" />
        <div v-if="!isLoadingUser">
            <div v-if="!isLoading">
                <h3 class="text-muted mb-4">{{ $t('values.networks') }}</h3>
                <h5 class="text-muted mb-3">{{ $t('values.valuersOf', { name: user.name }) }}</h5>
            </div>
            <networks :user="user" @loaded="isLoadingNetworks = false" />
            <div v-if="hasSubordinates && !isLoading" class="mt-4">
                <user-subordinates-networks :user="user" />
            </div>
        </div>
    </b-card>
</template>
<script>
import Networks from '../list/Networks'
import Loader from '@/views/components/loader'
import { getParam } from '@/lib/url'
import { getUser } from '@/views/values/api'
import UserSubordinatesNetworks from './components/UserSubordinatesNetworks'

export default {
    components: {
        Loader,
        Networks,
        UserSubordinatesNetworks,
    },
    data() {
        return {
            userId: getParam('userId', this),
            user: null,
            isLoadingUser: true,
            isLoadingNetworks: true,
        }
    },
    created() {
        this.getUser()
    },
    methods: {
        getUser() {
            this.isLoadingUser = true
            getUser(this.userId)
                .then((user) => {
                    this.user = user
                })
                .finally(() => {
                    this.isLoadingUser = false
                })
        },
    },
    computed: {
        isLoading() {
            return this.isLoadingUser || this.isLoadingNetworks
        },
        hasSubordinates() {
            return this.user.subordinates.length > 0
        },
    },
}
</script>
